<template>
  <form action="/catalog/search" method="get" class="box_row" @submit="submitForm">
    <div class="search-string-component">
      <div class="search-container">
        <input type="text" class="box_col-auto search_input" v-model="query"
               @keyup="dsearch"
               @focus="handleInputFocus"
               name="search_string"
               placeholder="Что вы хотите найти?"
               ref="searchInput">
        <div class="search-result" v-if="result.length>0">
          <ul>
            <li v-for="item in result" :key="item.uid"><a :class="{ 'category' : item.type=='category' }"
                                                          :href="item.href" v-html="item.name"></a></li>
          </ul>
        </div>
      </div>
    </div>
    <button type="submit" class="search_but box_col-1">
      <i class="icon-search"> </i>
    </button>
  </form>
</template>
<script>
import SearchMixin from './SearchMixin';

export default {
  name: 'SearchString',
  mixins: [SearchMixin]
}
</script>
<style lang="scss">
@import './SearchStyles.scss';
</style>